import { render, staticRenderFns } from "./googletest.vue?vue&type=template&id=c6538f48&scoped=true&"
import script from "./googletest.vue?vue&type=script&lang=js&"
export * from "./googletest.vue?vue&type=script&lang=js&"
import style0 from "./googletest.vue?vue&type=style&index=0&id=c6538f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6538f48",
  null
  
)

export default component.exports